import { Info } from 'lucide-react';

interface InformationNoteProps {
  hint?: string;
}

export const InformationNote = ({ hint }: InformationNoteProps) => (
  <div className="flex gap-3 p-3 bg-blue-50 border border-blue-300 rounded-lg">
    <Info size={18} className="text-blue-600 shrink-0 mt-0.5" />
    <p className="text-sm text-blue-800">
      {hint ?? 'Note: Please read carefully before proceeding.'}
    </p>
  </div>
);
